import axios, { AxiosResponse } from 'axios'

export const postApi = (
  url: string,
  data: unknown,
  params?: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, {
        params: params,
      })
      .then(function (response: AxiosResponse<unknown>) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

export const postAnynomus = (
  url: string,
  apiKey: string,
  data: unknown,
  params?: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, {
        params: params,
        headers: {
          'x-api-key': apiKey,
        },
      })
      .then(function (response: AxiosResponse<unknown>) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

export const getApi = (
  url: string,
  apiKey: string,
  params: unknown = {}
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('authToken')}`,
          'x-api-key': apiKey,
        },
      })
      .then(function (response: AxiosResponse<unknown>) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

//use these
export const post = (
  url: string,
  data?: unknown,
  params?: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, {
        params: params,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('authToken')}`,
        },
      })
      .then(function (response: AxiosResponse<unknown>) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}
export const patch = (
  url: string,
  data: unknown,
  params?: unknown
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    axios
      .patch(url, data, {
        params: params,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('authToken')}`,
        },
      })
      .then(function (response: AxiosResponse<unknown>) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

export const get = (url: string, params: unknown = {}): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('authToken')}`,
        },
      })
      .then(function (response: AxiosResponse<unknown>) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

export const del = (url: string, params?: unknown): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        params: params,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('authToken')}`,
        },
      })
      .then(function (response: AxiosResponse<unknown>) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

export const getApiParams = (
  url: string,
  params: unknown = {}
): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('authToken')}`,
        },
      })
      .then(function (response: AxiosResponse<unknown>) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}
